import * as React from 'react';
import { IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import {
  CanonicalCollections,
  LocaleToCanonicalCollections,
} from 'ha/constants/SearchPageCollections';
import SuggestionsLayout from './SuggestionsLayout';
import SuggestionsMobileLayout from './SuggestionsMobileLayout';
import {
  getFilteredCities,
  getFilteredApartments,
  getFilteredPrivateRooms,
} from '../../utils';
import { City } from '../../types';

interface Props {
  featuredCities?: City[];
  localizedApartmentSlug: string;
}

export const FeaturedSuggestions: React.SFC<Props & IntlProps> = ({
  featuredCities = [],
  localizedApartmentSlug,
  intl: { lang },
}) => {
  if (featuredCities.length === 0) {
    return null;
  }

  const cities = getFilteredCities(featuredCities);
  const apartments = getFilteredApartments(
    featuredCities,
    localizedApartmentSlug,
  );

  const localizedPrivateRoomSlug =
    LocaleToCanonicalCollections[lang][CanonicalCollections.PrivateRoomForRent];

  const rooms = getFilteredPrivateRooms(
    featuredCities,
    localizedPrivateRoomSlug,
  );

  return (
    <MediaQuery>
      {breakpoints => {
        const isMobile = !breakpoints.lg;

        if (isMobile) {
          return (
            <SuggestionsMobileLayout
              cities={cities}
              appartments={apartments}
              rooms={rooms}
            />
          );
        }

        return (
          <SuggestionsLayout
            cities={cities}
            appartments={apartments}
            rooms={rooms}
          />
        );
      }}
    </MediaQuery>
  );
};

export default FeaturedSuggestions;
